import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { forgetPasswordStart, forgetPasswordComplete } from '../../store/redux-slices/login'
import { getItem, getLoginToken } from '../../utils/storageUtils'
import { closeModal } from 'store/redux-slices/modal'
import { MODALS } from 'constants/modals'

const useForgotPassword = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { languageCode } = useParams()
  const { loading, forgetPass } = useSelector((state) => state.login)
  const { languageData, selectedLanguageCode} = useSelector((state) => state.language)
  const [language, setLanguage] = useState(languageCode || selectedLanguageCode?.toLowerCase() || getItem('language')?.toLowerCase())

  const [isEmailSent, setEmailSent] = useState(false)
  const [email, setEmail] = useState('')

  useEffect(() => {
    if (getLoginToken()) {
      dispatch(closeModal(MODALS.AUTH))
      navigate('/')
    }

    return () => dispatch(forgetPasswordComplete({ success: false }))
  }, [])

  useEffect(() => {
    if (forgetPass?.success) {
      setEmailSent(true)
    } else {
      setEmailSent(false)
    }
  }, [forgetPass])

  const handleForgotPassword = ({ email }) => {
    setEmail(email)
    dispatch(forgetPasswordStart({ email }))
  }

  return {
    handleForgotPassword,
    loading,
    isEmailSent,
    email,
    navigate,
    languageData,
    language,
    setLanguage
  }
}

export default useForgotPassword
